<template>
  <div class="wrapper-product">
    <MenuComponent
      logoUrl="assets/logos/LogoGreen.svg"
      textColor="var(--green)"
      menuIcon="assets/icons/MenuGreen.svg"
      closeIcon="assets/icons/CloseGreen.svg"
    />

    <div class="wrapper-general">
      <p class="title">FOTOGRAFÍA PRODUCTO PUBLICITARIO</p>
      <p class="subtitle">
        Potencia la imagen de tu marca con visuales impactantes
      </p>
      <div class="container">
        <div v-for="(image, index) in images" :key="index">
          <img :src="image.src" :alt="image.alt" class="file" />
        </div>
      </div>
    </div>

    <FooterComponent overlayColor="var(--green)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import { publicityGallery } from "@/data/product/publicityGallery.js";

export default {
  name: "PublicityGalleryView",
  components: {
    MenuComponent,
    FooterComponent,
  },

  data() {
    return {
      images: publicityGallery,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/product/styles/productGalleryStyle";
</style>
